import React from "react";
import { useHistory } from "react-router-dom";
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
  makeStyles,
  IconButton,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(4, 0),
  },
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
    boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(4),
    gap: theme.spacing(2),
  },
  content: {
    "& h2": {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(2),
      fontWeight: 700,
      color: theme.palette.primary.main,
    },
    "& p": {
      marginBottom: theme.spacing(2),
      lineHeight: 1.6,
      color: theme.palette.text.secondary,
    },
    "& ul": {
      marginBottom: theme.spacing(2),
      paddingLeft: theme.spacing(4),
      color: theme.palette.text.secondary,
    },
    "& li": {
      marginBottom: theme.spacing(1),
    },
  },
}));

const Privacy = () => {
  const classes = useStyles();
  const history = useHistory();

  const renderItems = (key) => {
    const items = i18n.t(key, { returnObjects: true });
    if (!Array.isArray(items)) return null;
    return (
      <ul>
        {items.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    );
  };

  return (
    <div className={classes.root}>
      <Container maxWidth="md">
        <Box className={classes.header}>
          <IconButton onClick={() => history.goBack()} color="primary">
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" style={{ fontWeight: 800 }}>
            {i18n.t("legal.privacy.title")}
          </Typography>
        </Box>

        <Paper className={classes.paper}>
          <Box className={classes.content}>
            <Typography variant="body1">
              {i18n.t("legal.privacy.lastUpdate")}: {new Date().toLocaleDateString()}
            </Typography>

            <Typography variant="h5" component="h2">
              {i18n.t("legal.privacy.s1.title")}
            </Typography>
            <Typography variant="body1">
              {i18n.t("legal.privacy.s1.content")}
            </Typography>

            <Typography variant="h5" component="h2">
              {i18n.t("legal.privacy.s2.title")}
            </Typography>
            <Typography variant="body1">
              {i18n.t("legal.privacy.s2.content")}
            </Typography>
            {renderItems("legal.privacy.s2.items")}

            <Typography variant="h5" component="h2">
              {i18n.t("legal.privacy.s3.title")}
            </Typography>
            <Typography variant="body1">
              {i18n.t("legal.privacy.s3.content")}
            </Typography>
            {renderItems("legal.privacy.s3.items")}

            <Typography variant="h5" component="h2">
              {i18n.t("legal.privacy.s4.title")}
            </Typography>
            <Typography variant="body1">
              {i18n.t("legal.privacy.s4.content")}
            </Typography>

            <Typography variant="h5" component="h2">
              {i18n.t("legal.privacy.s5.title")}
            </Typography>
            <Typography variant="body1">
              {i18n.t("legal.privacy.s5.content")}
            </Typography>

            <Typography variant="h5" component="h2">
              {i18n.t("legal.privacy.s6.title")}
            </Typography>
            <Typography variant="body1">
              {i18n.t("legal.privacy.s6.content")}
            </Typography>
            {renderItems("legal.privacy.s6.items")}

            <Typography variant="h5" component="h2">
              {i18n.t("legal.privacy.s7.title")}
            </Typography>
            <Typography variant="body1">
              {i18n.t("legal.privacy.s7.content")}
            </Typography>
          </Box>
        </Paper>
        
        <Box mt={4} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            onClick={() => history.goBack()}
            startIcon={<ArrowBackIcon />}
            style={{ borderRadius: 8, padding: "10px 24px" }}
          >
            {i18n.t("legal.back")}
          </Button>
        </Box>
      </Container>
    </div>
  );
};

export default Privacy;
